module.exports = __webpack_public_path__ + "img/hk.4a0f09ba.svg";